
<template>
    <div>
        <b-breadcrumb :items="itemsBread"></b-breadcrumb>
        <div class="my-3 mx-2">
            <div class="card p-3">
                <div class="p-2">
                    <h3>User List</h3>
                </div>
                <!-- page size  -->
                <b-row class="mt-2">
                    <b-col class="col-4 p-1" lg="3" md="4">
                        <b-form-group class="ms-2">
                            <b-form-select :options="pageOptions" @change="handlePageSizeChange" class="col-md-4"
                                id="per-page-select" size="sm" v-model="perPage"></b-form-select>
                        </b-form-group>
                    </b-col>
                    <!-- search  -->
                    <b-col>
                        <div class="d-flex flex-row d-flex justify-content-end">
                            <b-form-input v-model="filter" :formatter="searchFormatter" type="search"
                                placeholder="Type to filter data" class="me-2" style="width: 30%;"></b-form-input>
                            <button class="rounded btn-info me-4" @click="onSearch">Search</button>
                        </div>
                    </b-col>

                </b-row>
                <b-table responsive striped hover bordered :items="allUsers" :fields="fields" :per-page="perPage"
                    :current-page="currentPage" :busy="loading">
                    <template #cell(actions)="row">
                        <div class="d-flex gap-1 justify-content-center">
                            <button class="btn btn-info btn-sm " @click="revertUser(row.item)">
                                <i class="fa-solid fa-clock-rotate-left"></i>
                            </button>
                            <button class="btn btn-danger btn-sm " @click="deleteUser(row.item)"><span
                                    class="fa-solid fa-trash"></span></button>
                        </div>
                    </template>
                    <template #table-busy>
                        <div class="text-center text-danger my-2 px-2">
                            <b-spinner class="align-middle mx-2"></b-spinner>
                            <strong>Loading...</strong>
                        </div>
                    </template>
                </b-table>
                <!-- Pagination -->
                <b-row>
                    <b-col class="mt-2" md="12" sm="12">
                        <b-pagination :per-page="perPage" :total-rows="totalRows" @click="handlePageChange" align="center"
                            class="my-0" v-model="currentPage" prev-text="Prev" next-text="Next"></b-pagination>
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>
<script>
import userService from '@/services/user.service';
export default {
    setup() { },
    data() {
        return {
            itemsBread: [
                {
                    text: 'Home',
                    to: '/dashboard'
                }, {
                    text: 'User',
                    to: '/users/add'
                }, {
                    text: 'User Recycle Bin',
                    href: '#'
                }
            ],
            allUsers: [],
            fields: [
                {
                    label: 'Name', key: 'user_name', sortable: true, thStyle: { width: "22%" },
                    tdClass: "px-3", thClass: "px-3",
                },
                {
                    label: 'User ID', key: 'user_id', sortable: true,
                    thStyle: { width: "20%" }, tdClass: "px-3", thClass: "px-3",
                },
                {
                    label: 'Roles', key: 'rolesString', sortable: true, thStyle: { width: "23%" },
                    tdClass: "px-3", thClass: "px-3",
                },
                {
                    key: 'user_type', label: 'Categories', sortable: false,
                    class: 'text-center', thStyle: { width: "15%" },
                    formatter: (value) => {
                        return value == 2 ? 'External' : 'Internal'
                    },
                    filterByFormatted: true
                },
                { key: 'actions', label: 'Actions', class: 'text-center', thStyle: { width: "20%" }, },
            ],
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [5, 10, 100],
            backupAllUsers: null,
            filter: null,
            loading: false,
        };
    },
    created() {
        this.getAllUsers();
    },
    methods: {
        searchFormatter(data) {
            this.filter = data;
            if (this.filter != null && this.filter != "") {
                this.allUsers = [];
                this.backupAllUsers.forEach(user => {
                    if (user.user_name.toLowerCase().includes(this.filter.toLowerCase())) {
                        this.allUsers.push(user);
                    } else if (user.user_id.toLowerCase().includes(this.filter.toLowerCase())) {
                        this.allUsers.push(user);
                    } else if (user.user_email.toLowerCase().includes(this.filter.toLowerCase())) {
                        this.allUsers.push(user);
                    } else if (user.rolesString.toLowerCase().includes(this.filter.toLowerCase())) {
                        this.allUsers.push(user);
                    }
                });
            } else {
                this.allUsers = this.backupAllUsers;
            }
            this.totalRows = this.allUsers.length;
            this.currentPage = 1;
            return data;
        },
        onSearch() {
            if (this.filter != null && this.filter != "") {
                this.allUsers = [];
                this.backupAllUsers.forEach(user => {
                    if (user.user_name.toLowerCase().includes(this.filter.toLowerCase())) {
                        this.allUsers.push(user);
                    }
                });
            } else {
                this.allUsers = this.backupAllUsers;
            }
            this.totalRows = this.allUsers.length;
            this.currentPage = 1;
        },
        async deleteUser(user) {
            const result = await this.$swal({
                icon: "warning",
                title: "Are you sure?",
                text: "You won't be able to revert this deletion!",
                // title: 'Are you sure, you want to delete the User?',
                showCancelButton: true,
                cancelButtonText: 'No',
                cancelButtonColor: '#007bff',
                showConfirmButton: true,
                confirmButtonText: 'Delete',
                confirmButtonColor: '#dd3333',
            });
            if (result.isConfirmed) {
                this.loading = true;
                var response;
                try {
                    response = await userService.userHardDelete(user.id);
                } catch (error) {
                    this.loading = false;
                }
                this.loading = false;

                if (response.status === 200) {
                    this.getAllUsers();
                }
            }

        },
        async revertUser(user) {
            this.loading = true;
            var response;
            try {
                response = await userService.userRevert(user.id);
            } catch (error) {
                this.loading = false;
            }
            this.loading = false;
            if (response.status === 200) {
                this.getAllUsers();
            }
        },
        async getAllUsers() {
            const response = await userService.getAllDeletedUsers();
            this.allUsers = response.data;
            this.allUsers.forEach(user => {
                user.rolesString = "";
                user.roles = [];
                user.user_roles.forEach(roleDetails => {
                    user.roles.push(roleDetails.role_id);
                    if (user.rolesString === "") {
                        user.rolesString = user.rolesString + roleDetails.role_name;
                    } else {
                        user.rolesString = user.rolesString + ", " + roleDetails.role_name;
                    }
                });
            });
            this.backupAllUsers = response.data;
            this.totalRows = this.allUsers.length;

        }
    },
};
</script>

<style>
.hover-btn {
    display: none;
}

tr:hover .hover-btn {
    display: inline-block;
}

.text-sx {
    font-size: 13px;
}

.small-btn {
    --bs-btn-padding-y: 0.35rem;
    --bs-btn-padding-x: 0.6rem;
    --bs-btn-font-size: 0.7rem;
}
</style>
